import { Input, Divider, Select, Form, Col, Button, Table } from "antd";
import Typography from "../../Typography";
import { COLORS } from "../../../constants/Colors";
import MyInput from "../../Input";
import { useState, useRef, useEffect, useCallback, useContext } from "react";
import { Option } from "antd/es/mentions";
import useIsDesktop from "../../../utils/hooks/useIsDesktop";
import _ from "lodash";
import { FormattedMessage, useIntl } from "react-intl";
import CustomTable from "../../TableComponent";
import { QueueContext } from "./queue-context";
import { PlusOutlined } from "@ant-design/icons";

const { TextArea } = Input;

const QueueForm = (props) => {
  const {
    isEdit,
    onClickViewAllCustomer,
    customerData,
    form,
    isDisable,
    handleSelectName,
    lotParkList,
    deliveryType,
    columns,
    openAddProduct,
    contentAction,
    setTempData,
    tempData,
  } = props;

  const isDesktop = useIsDesktop();
  const selectCustomerRef = useRef();
  const intl = useIntl();
  const mockData = "default data text";
  const [dropdownchange, setDropdownchange] = useState(false);
  const { getFieldValue } = form;
  const { productList } = useContext(QueueContext);

  console.log("formformform", productList);
  const data = [{ qty: 1, uom: "test" }];

  // useEffect(() => {
  //   const reCheckData = () => {
  //     setTempData(productList)
  //   }

  //   if (_.size(productList) > 0) {
  //     reCheckData();
  //   }
  // }, [productList]);

  const handleClickViewAllCustomer = useCallback(
    (value) => {
      onClickViewAllCustomer();
      selectCustomerRef.current.blur(); //whenever a user triggers value change, we call `blur()` on `Select`
    },
    [onClickViewAllCustomer]
  );

  const handleOnkeyPressNumber = (event) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  };

  const layout = {
    wrapperCol: { span: 24 }, // กำหนดความกว้างของพื้นที่ที่บรรจุ Component
  };

  const handleSplitText = (value) => {
    const text = _.split(value, "·");
    // //console.log('SpliText',text);
    const filterName = text.slice(1).join(" ");
    return filterName ? filterName : value;
  };

  const handleZeroParcel = (rule, value, callback) => {
    if (value) {
      const parsValue = parseInt(value || 0);

      if (parsValue === 0) {
        callback(
          intl.formatMessage({
            id: "validateParcelThanZero",
            defaultMessage: "Parcel must be greater than 0",
          })
        );
      } else {
        callback();
      }
    } else {
      callback();
    }
  };

  return (
    <div
      className="d-flex flex-column pt-2"
      style={{ height: isDesktop ? undefined: '70vh' }}
    >
      <Form {...layout} form={form}>
        <div className={`d-flex ${isDesktop ? "flex-row" : "flex-column"}`}>
          <Col className={`px-0 ${isDesktop ? 'pr-2' : 'pr-0'}`} span={isDesktop ? 12 : 24}>
            <div className="w-100">
              <div className="d-flex align-items-center pb-1">
                <Typography color={COLORS.Purple} className="pb-1">
                  <FormattedMessage
                    id="createQueueFormLotPark"
                    defaultMessage="ช่องจอด เลขตู้"
                  />
                </Typography>
                <Typography
                  isBold
                  size="14px"
                  color={COLORS.Error}
                  className="pl-2"
                >
                  *
                </Typography>
              </div>
              <Form.Item
                name="lotpark"
                rules={[
                  {
                    required: true,
                    message: (
                      <FormattedMessage
                        id="createQueueFormLotParkVD"
                        defaultMessage="กรุณาเลือกช่องจอด"
                      />
                    ),
                  },
                ]}
              >
                <Select
                  className="w-100"
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder={intl.formatMessage({
                    id: "createQueueFormLotParkPH",
                    defaultMessage: "เลือกช่องจอด",
                  })}
                  onChange={(e) => handleSelectName(e)}
                  onSelect={(e) => handleSelectName(e)}
                  optionLabelProp="label"
                >
                  {lotParkList &&
                    _.map(lotParkList, (item, index) => {
                      return (
                        <Option
                          label={_.get(item, "join")}
                          key={_.get(item, "id")}
                          value={_.get(item, "id")}
                        >
                          {_.get(item, "join")}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </div>
          </Col>
          <Col className="px-0" span={isDesktop ? 12 : 24}>
            <div className="w-100">
              <div className="d-flex align-items-center pb-1">
                <Typography color={COLORS.Purple} className="pb-1">
                  <FormattedMessage
                    id="createQueueFormCustomer"
                    defaultMessage="ผู้ค้า / ลูกค้า"
                  />
                </Typography>
                <Typography
                  isBold
                  size="14px"
                  color={COLORS.Error}
                  className="pl-2"
                >
                  *
                </Typography>
              </div>
              <Form.Item
                name="customer"
                rules={[
                  {
                    required: true,
                    message: (
                      <FormattedMessage
                        id="createQueueFormCustomerVD"
                        defaultMessage="กรุณาเลือกผู้ค้า / ลูกค้า"
                      />
                    ),
                  },
                ]}
              >
                <Select
                  className="w-100"
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder={intl.formatMessage({
                    id: "createQueueFormCustomerPH",
                    defaultMessage: "เลือกผู้ค้า / ลูกค้า",
                  })}
                  onChange={(e) => handleSelectName(e)}
                  onSelect={(e) => handleSelectName(e)}
                  optionLabelProp="label"
                  dropdownRender={(menu) => {
                    return (
                      <>
                        {menu}
                        <Divider className="m-0" />
                        <div
                          onClick={onClickViewAllCustomer}
                          style={{ cursor: "pointer" }}
                        >
                          <Typography
                            color={COLORS.Purple}
                            className="px-2 py-3 mx-1"
                          >
                            <FormattedMessage
                              id="viewAllLoadmore"
                              defaultMessage="View All"
                            />
                          </Typography>
                        </div>
                      </>
                    );
                  }}
                >
                  {customerData &&
                    _.map(customerData, (item, index) => {
                      return (
                        <Option
                          label={
                            _.get(item, "serialNo") +
                            " " +
                            _.get(item, "assetName")
                          }
                          key={_.get(item, "id")}
                          value={_.get(item, "id")}
                        >
                          {_.get(item, "serialNo") +
                            " " +
                            _.get(item, "assetName")}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </div>
          </Col>
        </div>

        <div className={`d-flex ${isDesktop ? "flex-row" : "flex-column"}`}>
          <Col className={`px-0 ${isDesktop ? 'pr-2' : 'pr-0'}`} span={isDesktop ? 12 : 24}>
            <div className="w-100">
              <div className="d-flex align-items-center pb-1">
                <Typography color={COLORS.Purple} className="pb-1">
                  <FormattedMessage
                    id="createQueueFormTranType"
                    defaultMessage="วิธีจัดส่ง"
                  />
                </Typography>
                <Typography
                  isBold
                  size="14px"
                  color={COLORS.Error}
                  className="pl-2"
                >
                  *
                </Typography>
              </div>
              <Form.Item
                name="type"
                initialValue="TAS-DO"
                rules={[
                  {
                    required: true,
                    message: (
                      <FormattedMessage
                        id="createQueueFormTranTypePH"
                        defaultMessage="กรุณาเลือกวิธีจัดส่ง"
                      />
                    ),
                  },
                ]}
              >
                <Select
                  className="w-100"
                  placeholder={intl.formatMessage({
                    id: "placeholderCustomer",
                    defaultMessage: "Select Customer",
                  })}
                  onChange={(e) => handleSelectName(e)}
                  onSelect={(e) => handleSelectName(e)}
                  optionLabelProp="label"
                  //   defaultValue="TAS-DO"
                >
                  {deliveryType &&
                    _.map(deliveryType, (item, index) => {
                      return (
                        <Option
                          label={_.get(item, "typeLang")}
                          key={_.get(item, "orderTypeCode")}
                          value={_.get(item, "orderTypeCode")}
                        >
                          {_.get(item, "typeLang")}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </div>
          </Col>
          {/* <Col className="px-0" span={isDesktop ? 12 : 24}>
            <Form.Item
              name="carplate"
              rules={[
                {
                  required: getFieldValue("type") === "TAS-DO" ? false : true,
                  message: (
                    <FormattedMessage
                      id="createQueueFormRegisVD"
                      defaultMessage="กรุณาระบุทะเบียนรถ"
                    />
                  ),
                },
              ]}
            >
              <MyInput
                disabled={getFieldValue("type") === "TAS-DO" ? true : false}
                isRequired={getFieldValue("type") === "TAS-DO" ? false : true}
                label={
                  <FormattedMessage
                    id="createQueueFormRegis"
                    defaultMessage="ทะเบียนรถ"
                  />
                }
                placeHolder={intl.formatMessage({
                  id: "createQueueFormRegisPH",
                  defaultMessage: "ระบุทะเบียนรถ",
                })}
                className="w-100"
              />
            </Form.Item>
          </Col> */}
           <Col className={`px-0 ${isDesktop ? 'pr-2' : 'pr-0'}`} span={isDesktop ? 12 : 24}>
            {" "}
            <Form.Item name="ref">
              <MyInput
                // isRequired
                isBold={false}
                label={
                  <FormattedMessage
                    id="createQueueFormRef"
                    defaultMessage="อ้างอิง"
                  />
                }
                placeHolder={intl.formatMessage({
                  id: "createQueueFormRefPH",
                  defaultMessage: "ระบุอ้างอิง",
                })}
                className="pb-0 w-100"
                defaultValue={isEdit ? mockData : ""}
              />
            </Form.Item>
          </Col>
        </div>

        {/* <div className={`d-flex ${isDesktop ? "flex-row" : "flex-column"}`}>
          <Col className={`px-0 ${isDesktop ? 'pr-2' : 'pr-0'}`} span={isDesktop ? 12 : 24}>
            {" "}
            <Form.Item name="ref">
              <MyInput
                // isRequired
                isBold={false}
                label={
                  <FormattedMessage
                    id="createQueueFormRef"
                    defaultMessage="อ้างอิง"
                  />
                }
                placeHolder={intl.formatMessage({
                  id: "createQueueFormRefPH",
                  defaultMessage: "ระบุอ้างอิง",
                })}
                className="pb-0 w-100"
                defaultValue={isEdit ? mockData : ""}
              />
            </Form.Item>
          </Col>
        </div> */}
      </Form>
      <div className="pb-0 px-0 d-flex align-items-center justify-content-between" >
        <Typography style={{fontSize: '16px'}} isBold className="py-3 px-0" color={COLORS.Purple}>
          <FormattedMessage
            id="createQueueFormProduct"
            defaultMessage="สินค้า"
          />
        </Typography>

        <Button
          style={{
            backgroundColor: COLORS.GreenBrown,
            width: isDesktop ? null : "35px",
            padding: isDesktop ? null : "2px 5px",
            height: "35px",
            minWidth: isDesktop ? "97px" : undefined,
            borderRadius: "8px",
          }}
          type="primary"
          onClick={() => {
            openAddProduct();
          }}
        >
          {isDesktop ? (
            <FormattedMessage id="btnAdd" defaultMessage="เพิ่ม" />
          ) : <PlusOutlined /> }
        </Button>
      </div>
      <div
        style={{ margin: "10px -24px", borderTop: "1px solid #e5e5e5" }}
      ></div>
      {/* <Divider style={{position: 'relative',marginLeft:'-24px', marginRight: '-24px'}} className="mt-0" /> */}
      <CustomTable
        className="custom-table"
        column={columns}
        // data={_.size(productList) > 0 ? productList : []}
        style={{ fontSize: "14px" }}
        data={productList}
        pagination={false}
        scroll={{ x: _.sumBy(columns, "width") }}
        onRow={true}
        contentAction={contentAction}
        accessRole={true}
        rowKey={(o) => o.row_id}
      />
    </div>
  );
};

export default QueueForm;
